export const LOAD = '@storage/load';
export const LOADED = '@storage/loaded';
